import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionWizardModel} from '../../models/promotion-wizard.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PromotionWizardService extends IService<PromotionWizardModel> {

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'wizard')
  }

  getConfig(id: number): Observable<any> {
    return this._http.get(`/${this.baseUrl}/${this.entityUrl}/${id}/config`)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-wizard.service.ts